<template>
  <table class="table table-hover">
    <thead>
      <tr>
        <th width="60">Order</th>
        <th>Name</th>
        <th>Description</th>
        <th>Weight Limits</th>
        <th>Surcharges</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(group, index) in groups"
        :key="group.id"
        :draggable="!isSaving"
        @dragstart="dragStart(index)"
        @dragover.prevent
        @drop="drop(index)"
      >
        <td>
          <v-icon class="drag-handle" color="grey darken-1">
            mdi-drag
          </v-icon>
          {{ group.order || index + 1 }}
        </td>
        <td>{{ group.name }}</td>
        <td>{{ group.description }}</td>
        <td>{{ group.group_min_weight || 0 }} - {{ group.group_max_weight }}</td>
        <td>
          <!-- Surcharges column -->
          <span>
            {{
              (group.question_ids
                ? group.question_ids
                    .toString()
                    .split(',')
                    .map(id => surchargeLookup[id.trim()] || id.trim())
                    .join(', ')
                : '')
            }}
          </span>
        </td>
        <td>
            <v-switch
                class="switch"
                :disabled="isSaving"
                v-model="group.enabled"
                @change="switchShippingOption(group)"
                :label="group.enabled ? 'Enabled' : 'Disabled'"
                hide-details
                :loading="isSaving"
                dense>
            </v-switch>
        </td>
        <td>
          <v-btn x-small color="success" @click="$emit('edit', group)">Edit</v-btn>
          <v-btn x-small color="error" @click="$emit('delete', group)">Delete</v-btn>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "CarrierGroupsTable",
  props: {
    integrationId: {
      type: Number,
      required: true
    },
    groups: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isSaving: false,
      surchargeLookup: {
        "7": "Hydraulic Lift",
        "8": "Crane Truck",
        "13": "Residential",
        "14": "Authorised To Leave",
        "36": "Hand Unload"
      }
    };
  },
  computed: {
      ...mapGetters('LRSettingsState', {
          shopifyUserId: 'getShopifyUserId'
      })
  },
  methods: {
    dragStart(index) {
      this.$emit('drag-start', index);
    },
    drop(index) {
      this.$emit('drop', index);
    },
    switchShippingOption(shippingOption) {
        shippingOption.integration_id = this.integrationId
        shippingOption.shopifyUser = this.shopifyUserId

        this.isSaving = true;
        this.$http
            .patch(`/api/carrier-groupings/${shippingOption.id}`, shippingOption)
            .catch(err => {
                EventBus.$emit('show-error', err)
            }).finally(() => {
                this.isSaving = false;
            });
    },
  }
};
</script>
<style scoped>
.switch {
    margin: 0;
    padding: 0;
}

</style>
